import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function NewsLetter() {
  return (
    <div className="text-white text-center  bg-[#000000]">
      <div className="px-[5%] max-w-[1400px] mx-auto pt-20 pb-64 bgNewsletter">
        <h2 className="text-2xl font-bold">Explore Our Portfolio</h2>
        <p className="mt-4">
          Enter your email to receive our complete brand catalog and discover our premium product lineup.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10 mx-[20%]">
          {/* info@mardiin.com */}
          <Input
            className="bg-[#515151] border-none h-16 sm:w-[90%] min-w-[200px] placeholder:text-center placeholder:text-white"
            placeholder=" Enter your email address"></Input>
          <Button className="h-16 sm:w-[30%] font-extrabold">Request Catalog</Button>
        </div>
      </div>
    </div>
  );
}
